










import { Component, Prop, Vue , Watch } from 'vue-property-decorator';
@Component
export default class spikeCode extends Vue {
    @Prop({type: Object, default: () => ({})})   
         selectGoodsObj: any;
    @Prop({type: Object, default: () => ({})})   
         selectGoodsActivity: any;
    get goodsDesc(){
        return this.$store.getters["goods/getSpecification"]
    }
    codeSrc = '';
    code = ''
    created(){
        this.getSpikeCode();
    }
    getSpikeCode(){//获取秒杀验证码
      this.fetch({
        url: `${window.apis.getSpikeCode}?activityId=${this.goodsDesc.tagInfo['7070'].activityId}&itemId=${this.goodsDesc.currentSpec.itemId}`,
        data: {},
        noAstrict:true,
        method:'post'
      }).then((data:any) => {
          this.codeSrc =  'data:image/png;base64,' + data;
      })
    }
    changeCode(){
        this.getSpikeCode();
    }
    rroofreadingCode(){
        this.fetch({
        url: `${window.apis.rroofreadingCode}?activityId=${this.goodsDesc.tagInfo['7070'].activityId}&itemId=${this.goodsDesc.currentSpec.itemId}`,
        data: {validateCode:this.code},
        method:'post'
        }).then((res: any) => {
            console.log(res);
            this.submitSpike();
        })
    }
    submitSpike(){//提交秒杀订单
        let data={
            itemNumMap: this.selectGoodsObj,
            activityMap:this.selectGoodsActivity,
            seckillFlag:true,//是否秒杀  Boolean
        }
        this.fetch({ //接口wiki地址 http://wiki.uletm.com/pages/viewpage.action?pageId=36478237
            url: window.apis.createOrder,
            data: data
        }).then((res: any) => {
            window.location.href = '//wholesale'+ window.domain +'/fxPayOrder/payment/paymentReq.do?orderIds=' + res;//下单成功跳转的页面
        })
    }

}
